(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"]) return;
  try {
    
(function() {
  // Copy article URL on share-btn click
  document.querySelectorAll('[data-art-copy]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var url = btn.getAttribute('data-art-copy');
      if (!url || !navigator.clipboard) return;
      navigator.clipboard.writeText(url).then(function() {
        var orig = btn.getAttribute('aria-label');
        btn.setAttribute('aria-label', 'Link copied');
        btn.style.background = 'var(--color-primary, #0d775f)';
        btn.style.color = '#fff';
        btn.style.borderColor = 'var(--color-primary, #0d775f)';
        setTimeout(function() {
          btn.setAttribute('aria-label', orig);
          btn.style.background = '';
          btn.style.color = '';
          btn.style.borderColor = '';
        }, 1500);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
(function() {
  var form = document.getElementById('CartPageForm');
  if (!form) return;

  function money(cents) {
    var rupees = Math.round(cents / 100);
    return '₹' + rupees.toLocaleString('en-IN');
  }

  function updateBadges(itemCount) {
    document.querySelectorAll('.header-cart-count').forEach(function(el){ el.textContent = itemCount; });
  }

  function changeItem(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function(r){ return r.json(); });
  }

  // +/- buttons
  form.addEventListener('click', function(e) {
    var step = e.target.closest('[data-cart-step]');
    if (step) {
      var wrap = step.closest('[data-cart-qty]');
      var input = wrap.querySelector('[data-cart-input]');
      var current = parseInt(input.value, 10) || 0;
      var delta = parseInt(step.getAttribute('data-cart-step'), 10);
      var next = Math.max(0, current + delta);
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) {
      e.preventDefault();
      rm.disabled = true;
      changeItem(rm.getAttribute('data-key'), 0).then(function(){
        window.location.reload();
      });
    }
  });

  // qty input change → AJAX update + reload (full reload keeps totals accurate)
  form.addEventListener('change', function(e) {
    var input = e.target.closest('[data-cart-input]');
    if (!input) return;
    var wrap = input.closest('[data-cart-qty]');
    if (!wrap) return;
    var key = wrap.getAttribute('data-key');
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    changeItem(key, qty).then(function(cart){
      updateBadges(cart.item_count);
      window.location.reload();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Mobile sidebar toggle
  var sidebar = document.getElementById('ShopSidebar');
  var openBtn = document.getElementById('OpenSidebar');
  var closeBtn = document.getElementById('CloseSidebar');
  if (openBtn && sidebar) openBtn.addEventListener('click', function(){ sidebar.classList.add('open'); openBtn.setAttribute('aria-expanded','true'); });
  if (closeBtn && sidebar) closeBtn.addEventListener('click', function(){ sidebar.classList.remove('open'); if (openBtn) openBtn.setAttribute('aria-expanded','false'); });

  // Sort: auto-submit
  var sortSelect = document.getElementById('SortBy');
  if (sortSelect) {
    sortSelect.addEventListener('change', function(){
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  // Dual price range slider — keep min < max, sync number inputs, paint range fill
  var slider = document.querySelector('.shop-price__slider');
  if (!slider) return;
  var minR = document.getElementById('PriceMinRange');
  var maxR = document.getElementById('PriceMaxRange');
  var minI = document.getElementById('PriceMinInput');
  var maxI = document.getElementById('PriceMaxInput');
  var range = document.getElementById('PriceRange');
  var display = document.getElementById('PriceDisplay');
  var max = parseFloat(slider.dataset.max) || 0;

  function paint() {
    var lo = parseFloat(minR.value);
    var hi = parseFloat(maxR.value);
    if (hi - lo < 1) {
      if (this === minR) lo = hi - 1;
      else hi = lo + 1;
    }
    var pctLo = max > 0 ? (lo / max) * 100 : 0;
    var pctHi = max > 0 ? (hi / max) * 100 : 100;
    range.style.left = pctLo + '%';
    range.style.right = (100 - pctHi) + '%';
    if (minI && document.activeElement !== minI) minI.value = Math.round(lo);
    if (maxI && document.activeElement !== maxI) maxI.value = Math.round(hi);
    if (display) display.textContent = '₹' + Math.round(lo) + ' – ₹' + Math.round(hi);
  }

  function syncFromInputs() {
    var lo = parseFloat(minI.value) || 0;
    var hi = parseFloat(maxI.value) || max;
    if (lo < 0) lo = 0;
    if (hi > max) hi = max;
    if (lo > hi) lo = hi;
    minR.value = lo; maxR.value = hi;
    paint.call(minR);
  }

  if (minR) minR.addEventListener('input', paint.bind(minR));
  if (maxR) maxR.addEventListener('input', paint.bind(maxR));
  if (minI) minI.addEventListener('change', syncFromInputs);
  if (maxI) maxI.addEventListener('change', syncFromInputs);
  paint.call(minR);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-certifications"] && !Shopify.designMode) return;
  try {
    
(function () {
  var modal = document.getElementById('CertRequestModal');
  if (!modal) return;

  var form      = document.getElementById('CertRequestForm');
  var iframe    = modal.querySelector('.certs-modal__iframe');
  var formWrap  = modal.querySelector('[data-cert-form-wrap]');
  var thanks    = modal.querySelector('[data-cert-thanks]');
  var docField  = modal.querySelector('[data-cert-doc-field]');
  var bodyField = modal.querySelector('[data-cert-body-field]');
  var docLabel  = modal.querySelector('[data-cert-doc-label]');
  var defaultLabel = docLabel ? docLabel.textContent : '';
  var awaitingResponse = false;

  // Route the native Shopify contact form into the hidden iframe so we can
  // show an in-place thank-you instead of navigating away.
  if (form && iframe) form.setAttribute('target', 'cert_form_iframe');

  function openModal(doc) {
    if (docField)  docField.value  = doc || 'Price list';
    if (bodyField) bodyField.value = 'Price list request: ' + (doc || '');
    if (docLabel && doc) docLabel.textContent = 'Requesting: ' + doc;
    else if (docLabel) docLabel.textContent = defaultLabel;
    if (formWrap) formWrap.hidden = false;
    if (thanks)   thanks.hidden   = true;
    awaitingResponse = false;
    if (typeof modal.showModal === 'function') { try { modal.showModal(); } catch (e) { modal.setAttribute('open', ''); } }
    else modal.setAttribute('open', '');
  }

  function closeModal() {
    if (typeof modal.close === 'function') { try { modal.close(); } catch (e) { modal.removeAttribute('open'); } }
    else modal.removeAttribute('open');
  }

  document.querySelectorAll('[data-cert-request]').forEach(function (btn) {
    btn.addEventListener('click', function () { openModal(btn.getAttribute('data-doc')); });
  });

  modal.querySelectorAll('[data-cert-close]').forEach(function (b) {
    b.addEventListener('click', closeModal);
  });

  // Click on the backdrop (outside the box) closes
  modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });

  if (form) {
    form.addEventListener('submit', function () { awaitingResponse = true; });
  }

  if (iframe) {
    iframe.addEventListener('load', function () {
      if (!awaitingResponse) return; // ignore the initial (empty) load
      awaitingResponse = false;
      if (formWrap) formWrap.hidden = true;
      if (thanks)   thanks.hidden   = false;
      if (form)     form.reset();
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-our-story-mission"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sections = document.querySelectorAll('.osm');
  if (!('IntersectionObserver' in window)) {
    sections.forEach(function(s) { s.classList.add('osm--in'); });
    return;
  }
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        e.target.classList.add('osm--in');
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -80px 0px', threshold: 0.05 });
  sections.forEach(function(s) { io.observe(s); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-related-products"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sec = document.currentScript ? document.currentScript.closest('.related') : null;
  // Fallback: pick the LAST .related on the page (we just rendered it)
  if (!sec) {
    var all = document.querySelectorAll('.related[data-url]');
    sec = all[all.length - 1];
  }
  if (!sec || !sec.dataset.url) return;
  // If Liquid already inlined recommendations (recommendations.performed), skip the fetch
  if (sec.querySelector('.related__grid')) return;

  fetch(sec.dataset.url)
    .then(function(r){ return r.text(); })
    .then(function(html){
      var temp = document.createElement('div');
      temp.innerHTML = html;
      var fresh = temp.querySelector('.related .related__grid') || temp.querySelector('.related__grid');
      if (fresh) {
        sec.querySelector('.container').appendChild(fresh);
      } else {
        // Nothing to show — hide the section so the title doesn't sit alone
        sec.style.display = 'none';
      }
    })
    .catch(function(){ sec.style.display = 'none'; });
})();

  } catch(e) { console.error(e); }
})();
})();
